import React from 'react';

const EditReservationModal = ({ editingReservation, setEditingReservation, onSubmit, statusLabels }) => {
  if (!editingReservation) return null;

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="modal fade" id="editReservationModal" tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Modifier la réservation #{editingReservation.id}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <form onSubmit={onSubmit}>
            <div className="modal-body">
              <div className="alert alert-info">
                <strong>Utilisateur :</strong>{' '}
                {editingReservation.user ? (
                  `${editingReservation.user.username || '-'} (${editingReservation.user.email || '-'})`
                ) : editingReservation.user_details ? (
                  <>
                    {editingReservation.user_details.name || '-'} ({editingReservation.user_details.email || '-'})
                    <span className="badge bg-secondary ms-2">Invité</span>
                  </>
                ) : (
                  'Aucun utilisateur'
                )}
                <br />
                <strong>Atelier :</strong> {editingReservation.workshop?.title || '-'}
              </div>

              <div className="mb-3">
                <label className="form-label">Dates réservées</label>
                <div className="border rounded p-3 bg-light">
                  {editingReservation.workshop_date && editingReservation.workshop_date.length > 0 ? (
                    editingReservation.workshop_date.map((date, idx) => (
                      <div key={idx} className="mb-1">
                        <i className="bi bi-calendar-event me-2"></i>
                        {formatDate(date.date)}
                      </div>
                    ))
                  ) : (
                    <span className="text-muted">Aucune date associée</span>
                  )}
                </div>
                <small className="text-muted">
                  Note : Pour modifier les dates, veuillez créer une nouvelle réservation.
                </small>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Statut *</label>
                  <select
                    className="form-select"
                    value={editingReservation.resa_status}
                    onChange={(e) => setEditingReservation({
                      ...editingReservation,
                      resa_status: e.target.value
                    })}
                    required
                  >
                    {Object.keys(statusLabels).map(status => (
                      <option key={status} value={status}>
                        {statusLabels[status]}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Prix total</label>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control"
                    value={editingReservation.total_price || 0}
                    onChange={(e) => setEditingReservation({
                      ...editingReservation,
                      total_price: e.target.value
                    })}
                  />
                </div>
              </div>

              <hr />

              <h6>Détails utilisateur</h6>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Nom</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editingReservation.user_details?.name || ''}
                    onChange={(e) => setEditingReservation({
                      ...editingReservation,
                      user_details: {
                        ...editingReservation.user_details,
                        name: e.target.value
                      }
                    })}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={editingReservation.user_details?.email || ''}
                    onChange={(e) => setEditingReservation({
                      ...editingReservation,
                      user_details: {
                        ...editingReservation.user_details,
                        email: e.target.value
                      }
                    })}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label">Téléphone</label>
                  <input
                    type="tel"
                    className="form-control"
                    value={editingReservation.user_details?.phone || ''}
                    onChange={(e) => setEditingReservation({
                      ...editingReservation,
                      user_details: {
                        ...editingReservation.user_details,
                        phone: e.target.value
                      }
                    })}
                  />
                </div>
              </div>

              <div className="alert alert-warning">
                <small>
                  <i className="bi bi-info-circle me-2"></i>
                  <strong>Note :</strong> Pour annuler une réservation, changez le statut à "Annulée".
                </small>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Annuler
              </button>
              <button type="submit" className="btn btn-primary">
                Enregistrer les modifications
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditReservationModal;
